import thunk from 'redux-thunk';
import assets from './assets';
import blocks from './blocks';
import history from './history';
import site from './site';
import template from './template';
import view from './view';
import savingManager from './saving';
import interrupter from './interrupter';
import client from './service-client';
import globals from './globals';
import branding from './branding';
import i18n from './i18n';
import hooks from './hooks';
import contentEditable from './content-editable';
import siteLocales from './site-locales';
import textFormatting from './text-formatting';
import logger from './logger';
import transactions from './transactions';

export default [
  thunk,
  hooks.middleware.before,
  logger.middleware.logBeforeReloadAction,
  site.middleware.siteLoader,
  template.middleware.metaLoader,
  view.middleware.viewStatusChanger,
  siteLocales.middleware.markupCleaner,
  siteLocales.middleware.siteLocales,
  site.middleware.foldersValidator,
  site.middleware.pageFetcher,
  site.middleware.pageSettings,
  globals.middleware.globalLoader,
  globals.middleware.updateGlobalHtmlBySettings,
  globals.middleware.synchronizeNavigationGlobal,
  globals.middleware.detachGlobal,
  globals.middleware.globalHTML,
  globals.middleware.resetGlobal,
  blocks.middleware.blockFetcher,
  template.middleware.templateFetcher,
  interrupter.middleware.interruptionPoint,
  interrupter.middleware.interrupter,
  site.middleware.pageCreator,
  history.middleware.mutationCreator,
  transactions.middleware.resetTransactionSession,
  view.middleware.scroll,
  view.middleware.changeHTML,
  view.middleware.updateAtomicCSS,
  view.middleware.setInlineElementStyle,
  view.middleware.setElementAttribute,
  view.middleware.removeElementAttribute,
  view.middleware.copyElement,
  view.middleware.pasteElement,
  view.middleware.insertBlock,
  view.middleware.deleteElement,
  view.middleware.insertElement,
  view.middleware.replaceElement,
  view.middleware.shiftElement,
  view.middleware.duplicateElement,
  view.middleware.blurFocusedElement,
  view.middleware.synchronizeElement,
  view.middleware.setChildrenPresence,
  view.middleware.bulkPageChanges,
  site.middleware.pageRemoval,
  view.middleware.disableView,
  history.middleware.mutationInverter,
  contentEditable.middleware.historyManager,
  savingManager.middleware.savingManager,
  client.middleware.clientLoader,
  branding.middleware.colorsInjector,
  assets.middleware.assetsUploader,
  i18n.middleware.localeSetter,
  template.middleware.metaTranslationsLoader,
  i18n.middleware.translationLoader,
  textFormatting.middleware.customColors,
  site.middleware.siteExporter,
  site.middleware.pageUsedBlocksTracker,
];
